import React, { Component } from 'react';
import logo2 from '../assets/logo2.png';
import { Link } from 'react-router-dom';



class Classes extends Component {
  state = { walletInfo: {} };
  render() {
    const { address, balance } = this.state.walletInfo;
    return (
      <div className='Classes'>
      <div><Link to='/'>Home</Link></div>
      <h3>Aikido Wong Wian Yai Dojo's Classes</h3>

      <br />
      <br />

        <div><Link to='/rosterwongwianyai'>Monday 19.00-22.00</Link></div>
        <br />
        <div><Link to='/rosterwongwianyai'>Tuesday 19.00-22.00</Link></div>
        <br />
        <div><Link to='/rosterwongwianyai'>Wednesday 19.00-22.00</Link></div>
        <br />
        <div><Link to='/rosterwongwianyai'>Thursday 19.00-22.00</Link></div>
        <br />
        <div><Link to='/rosterwongwianyai'>Friday 19.00-22.00</Link></div>
        <br />
        <div>
          Thailand's Aikido Association Class Attending System...
        </div>
          <br />
          <br />
        <div>Powered by</div><img className='logo2' src={logo2}></img><div>New Wave Consulting Group</div>
      </div>
    );
  }
}
export default Classes;
